import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { SeleccionProductoRequest } from 'src/app/global/interfaces/seleccion-producto.request';
import { SeleccionProductoResponse } from 'src/app/global/interfaces/seleccion-producto.response';
import { environment } from 'src/environments/environment';
import { ConfiguracionProducto } from '../../../interfaces/configuracion-producto';
import { ProductosService } from '../../../services/productos.service';

@Injectable()
export class ProductosProvider extends ProductosService {

  private api = environment.api;
  private endpoints = this.api.endpoints;

  constructor(private http: HttpClient) {
    super();
  }

  registraSeleccionProducto(productos: SeleccionProductoRequest[]): Observable<any> {
    let productoARegistrar = null;
    if (productos && productos.length > 0) {
      productoARegistrar = productos[0];
    }

    const endopoint = this.api.host + this.api.path + this.endpoints.PASO_2.SELECCION_PRODUCTO;
    return this.http.post(endopoint, productoARegistrar);
  }

  validaPagoProducto(producto: any): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.PASO_3.VALIDA_PAGO_PRODUCTO;
    return this.http.post(endopoint, producto);
  }

  obtenerUrlPago(data: string): Observable<any> {
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_3.OBTENER_URL_PAGO;
    return this.http.post<any>(endpoint, data);
  }

  obtenerSeleccionProductos(): Observable<SeleccionProductoResponse> {
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_2.SELECCION_PRODUCTO;
    return this.http.get<SeleccionProductoResponse>(endpoint);
  }

  postConfiguracionProducto(data: any): Observable<any> {
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_2.CONFIGURACION_PRODUCTO;
    return this.http.post(endpoint, data);
  }

  obtenerConfiguracionProducto(): Observable<ConfiguracionProducto> {
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_2.CONFIGURACION_PRODUCTO;
    return this.http.get<ConfiguracionProducto>(endpoint);
  }

  obtenerResumenPago(): Observable<any> {
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_3.OBTIENE_RESUMEN_PAGO;
    return this.http.get(endpoint);
  }

  validaPagoProductoEjecutivo(run: number): Observable<GeneralResponse<any>>{
    const endpoint = this.api.host + this.api.path + this.endpoints.PASO_3.VALIDA_PAGO_PRODUCTO_EJECUTIVO + run;
    return this.http.get<GeneralResponse<any>>(endpoint);
  }

  obtenerValorUF(): Observable<any> {
    const endopoint = this.api.host + this.api.pathMarketplace + this.endpoints.marketplace.UF;
    return this.http.get(endopoint);
  }

  validarDescuento(descuento: String): Observable<any>{
    const endopoint = this.api.host + this.api.path + this.endpoints.PASO_3.VALIDA_DESCUENTO+descuento;
    return this.http.get(endopoint);
  }

  obtenerValoresMCC(): Observable<any> {
    const endopoint = this.api.host + this.api.pathMarketplace + this.endpoints.marketplace.valoresMCC;
    return this.http.get(endopoint);
  }
}
